import {
  Alert,
  Button,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DataSourceBadge } from '../../shared/data/DataSourceBadge';
import { mockActiveSessions } from './mockSessions';

/**
 * DEV Mock Auth only. There is no session-listing or session-revocation endpoint in the current
 * OpenAPI contract, so this panel renders deterministic, clearly-labeled Mock Data and offers a
 * local-only sign-out/reset affordance. It never calls a repository or API client method.
 */
export function ActiveSessionsPanel() {
  const { t } = useTranslation();
  const [endedIds, setEndedIds] = useState<ReadonlySet<string>>(new Set());

  const endOtherSessions = () => {
    setEndedIds(
      new Set(
        mockActiveSessions.filter((session) => !session.current).map((session) => session.id),
      ),
    );
  };
  const reset = () => setEndedIds(new Set());

  return (
    <Paper component="section" sx={{ p: 2 }} variant="outlined">
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography component="h2" variant="subtitle1">
            {t('profile.sessions.title')}
          </Typography>
          <DataSourceBadge source="mock" />
        </Stack>
        <Alert severity="info">{t('profile.sessions.mockNotice')}</Alert>
        <List disablePadding>
          {mockActiveSessions.map((session) => {
            const ended = endedIds.has(session.id);
            return (
              <ListItem disableGutters divider key={session.id}>
                <ListItemText
                  primary={session.device}
                  secondary={
                    ended
                      ? t('profile.sessions.ended')
                      : `${session.location} · ${session.ipAddress}`
                  }
                />
              </ListItem>
            );
          })}
        </List>
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
          <Button onClick={endOtherSessions} size="small" variant="outlined">
            {t('profile.sessions.signOutOthersMock')}
          </Button>
          <Button onClick={reset} size="small" variant="text">
            {t('profile.sessions.resetMock')}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
